<script>
import { mapGetters } from 'vuex'
import VueAnalytics from 'vue-analytics'
import Vue from 'vue'
import router from '@/router'

export default 
{
    name: 'trackers',

    computed: mapGetters(['channel', 'deferred']),

    methods:
    {
        setupTracking()
        {
            if (this.channel && this.channel.tracking_google)
            {
                Vue.use(VueAnalytics, {
                    id: this.channel.tracking_google,
                    router,
                    /*
                    debug: {
                        enabled: process.env.NODE_ENV == 'production',
                        sendHitTask: process.env.NODE_ENV != 'production'
                    },
                    */
                })
                this.$ga.event('pageview')
            }

            if (this.channel && this.channel.tracking_facebook)
            {
                if (process.env.NODE_ENV == 'production')
                {
                    Vue.analytics.fbq.init(this.channel.tracking_facebook, {
                        em: process.env.PIXEL_MAIL
                    })
                    this.$analytics.fbq.event('PageView')
                }
            }

        },
    },

    render(h)
    {
        return h('div')
    },

    mounted()
    {
        this.deferred.promise.then(() => {
            this.setupTracking()
        })
    },
    
}
</script>



// WEBPACK FOOTER //
// src/components/elements/Trackers.vue